import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import paths from '../paths';
import { createLazyComponent, createRoute } from 'constants/utils';
import { NavigationTabLayout } from 'components/organism/TabGroups/NavigationTabLayout';
const MerchantAccounts = lazy(() => import('../../components/pages/payment/merchantAccounts/MerchantAccounts'));
const Corporations = lazy(() => import('../../components/pages/payment/corporations/Corporations'));
const Banks = lazy(() => import('../../components/pages/payment/banks/Banks'));
const Pools = lazy(() => import('../../components/pages/payment/pools/Pools/Pools'));
const PoolDetails = lazy(() => import('../../components/pages/payment/pools/Details/Details'));
const BinRoutings = lazy(() => import('../../components/pages/payment/binRouting/BinRouting/BinRouting'));
const BinRoutingDetails = lazy(() => import('../../components/pages/payment/binRouting/BinRouting/Details/Details'));
const CardBins = lazy(() => import('../../components/pages/payment/binRouting/CardBins/CardBins'));
const BadBins = lazy(() => import('../../components/pages/payment/binRouting/BadBins/BadBins'));
const MerchantProfiles = lazy(() => import('../../components/pages/payment/gatewayProfiles/MerchantProfiles/MerchantProfiles'));
const MerchantProfileDetails = lazy(() => import('../../components/pages/payment/gatewayProfiles/Details/Details'));
const Schedules = lazy(() => import('../../components/pages/payment/settings/Retries/Retries'));
const ReprocFlowMapping = lazy(() => import('../../components/pages/payment/settings/ReprocFlowMapping/ReprocFlowMapping'));
const RebillFlowMapping = lazy(() => import('../../components/pages/payment/settings/RebillFlowMapping/RebillFlowMapping'));
const UpsellsFlowMapping = lazy(() => import('../../components/pages/payment/settings/UpsellFlowMapping/UpsellFlowMapping'));

const binTabs = [
  {
    name: 'Bin Routing',
    value: 'bin-routings',
    path: paths.binRoutings,
  },
  {
    name: 'International BINs',
    value: 'card-bins',
    path: paths.cardBins,
  },
  {
    name: 'Bad BINs',
    value: 'bad-bins',
    path: paths.badBins,
  },
];

export const paymentRoutes = (abilities) => {
  const routes = [
    (abilities?.gateway?.read ?? false) && createRoute(paths.merchantAccounts, MerchantAccounts),
    (abilities?.corporation?.read ?? false) && createRoute(paths.corporations, Corporations),
    (abilities?.bank?.read ?? false) && createRoute(paths.banks, Banks),
    (abilities?.pool?.read ?? false) && createRoute(paths.pools, Pools),
    (abilities?.pool?.read ?? false) && createRoute(paths.poolDetails(), PoolDetails),
    ((abilities?.bin_routing?.read ?? false) && {
      path: paths.binRoutings,
      element: <NavigationTabLayout tabs={binTabs} />,
      children: [{
        index: true,
        element: createLazyComponent(BinRoutings),
      },
      createRoute(paths.cardBins, CardBins),
      createRoute(paths.badBins, BadBins),
      ],
    }),
    (abilities?.bin_routing?.read ?? false) && createRoute(paths.binRoutingDetails(), BinRoutingDetails),
    (abilities?.gateway_profile?.read ?? false) && createRoute(paths.merchantProfiles, MerchantProfiles),
    (abilities?.gateway_profile?.read ?? false) && createRoute(paths.merchantProfileDetails(), MerchantProfileDetails),
    (abilities?.settings?.read ?? false) && createRoute(paths.retries, Schedules),
    (abilities?.settings?.read ?? false) && createRoute(paths.reprocflowMapping, ReprocFlowMapping),
    (abilities?.settings?.read ?? false) && createRoute(paths.rebillflowMapping, RebillFlowMapping),
    (abilities?.settings?.read ?? false) && createRoute(paths.upsell, UpsellsFlowMapping),
  ].filter(Boolean);

  const firstPermittedPath = routes[0]?.path || '/*';

  return {
    path: paths.getPaymentLayout,
    children: [
      {
        index: true,
        element: (
          <Navigate
            replace={true}
            to={firstPermittedPath}
          />
        ),
      },
      ...routes,
      {
        path: paths.settings,
        element: <Navigate to={paths.retries} />,
      },
    ],
  };
};
